import { useBreakpoint, UseBreakpointOptions } from '@chakra-ui/react';
import { IInvoiceRespSchema } from '@monetize/types/app';
import { FunctionComponent as FC } from 'react';
import { FiDownload } from 'react-icons/fi';
import { doPrintInvoicePdfForInvoiceShare } from '../../../api/shareService';
import { MCustomIconButton, MHStack } from '../../../components/Monetize';
import DataTableActions, {
  ActionType,
} from '../../../components/Monetize/DataTable/MDataTableActions';
import { downloadAndSaveToPDF } from '../../../utils';

// v3's `useBreakpoint` only reports breakpoints it's asked to watch (with
// none, it always returns its `'base'` fallback). These are the ones this
// layout tells apart; anything wider reads as `'md'`, i.e. desktop.
const LAYOUT_BREAKPOINTS: UseBreakpointOptions = {
  breakpoints: ['base', 'sm', 'md'],
};

interface InvoiceActionProps {
  invoice: IInvoiceRespSchema;
  invoiceSecretId: string;
  tenantId: string;
}

export const ViewInvoiceActions: FC<InvoiceActionProps> = ({
  invoice,
  invoiceSecretId,
  tenantId,
}: InvoiceActionProps) => {
  const breakpoint = useBreakpoint(LAYOUT_BREAKPOINTS);
  if (!invoice) {
    return null;
  }

  const handlePrintToPdf = async () => {
    downloadAndSaveToPDF(() =>
      doPrintInvoicePdfForInvoiceShare(
        tenantId,
        invoiceSecretId,
        invoice.id,
        invoice.invoiceNumber,
      ),
    );
  };

  const actions: ActionType[] = [
    {
      title: 'Download Invoice',
      enabled: true,
      action: () => handlePrintToPdf(),
    },
  ];

  return (
    <>
      {['base', 'sm'].includes(breakpoint) ? (
        <MHStack ml={0} gap={0}>
          <MCustomIconButton
            variant="icon"
            btnSize={breakpoint === 'base' ? 8 : 6}
            p={3}
            _focus={{ bg: 'none' }}
            icon={FiDownload}
            aria-label="Download invoice"
            color="tPurple.dark"
            onClick={() => handlePrintToPdf()}
          />
        </MHStack>
      ) : (
        <DataTableActions actions={actions} />
      )}
    </>
  );
};
